<template>
    <base-page
        :content="content"
        :pic="IMAGE_MAP.EXPIRED_PAGE_ICON"
    ></base-page>
</template>

<script>
import BasePage from './BasePage.vue';
import { getFixedImgUrl } from '@/utils/dynamic-cdn';
const IMAGE_MAP = getFixedImgUrl();

export default {
    name: 'expired-page',
    components: {
        BasePage,
    },
    data() {
        return {
            content: [
                '您访问的链接已经失效',
                '请重新联系快手客服',
            ],
            IMAGE_MAP,
        };
    },
};
</script>
